$(function ($) {
  /*---------------- HEADER START ------------------*/
  ! function() {
    var t = $(".main-header:not(.main-header.sticky-header)"),
        e = $(t).find(".main-menu-content .navbar-nav"),
        n = $(t).find(".upper-navigation .upper-menu-right .navbar-nav"),
        i = $(document).find(".main-header.sticky-header .main-menu-content .navbar-nav"),
        r = $(document).find(".main-header.sticky-header .upper-menu-right .navbar-nav"),
        s = parseInt($(".main-header:not(.main-header.sticky-header)").data("menu-limit"));
    $(e).prepend('<li class="nav-menu-item-placeholder hidden"></li>'), $(i).prepend('<li class="nav-menu-item-placeholder hidden"></li>'), ($(t).hasClass("header-logo-left") || $(t).hasClass("header-logo-right")) && ($(t).find(".main-menu.main-menu-init .navbar-nav > .nav-item.nav-menu-item:not(.nav-menu-item-home)").each(function(t) {
      var a = $(this);
      t < s && ($(e).children(".nav-menu-item-placeholder").before(a.clone(!0)), $(i).children(".nav-menu-item-placeholder").before(a.clone(!0))), t >= s && ($(n).append(a.clone(!0)), $(r).append(a.clone(!0)), $(document).find(".main-header .upper-navigation").addClass("has-upper-header-menu"))
    }), $(e).children(".nav-menu-item-placeholder").remove(), $(i).children(".nav-menu-item-placeholder").remove())
  }(), $(".main-header .main-menu .navbar-nav .has-dropdown-menu, .main-header .upper-menu .navbar-nav .has-dropdown-menu").hover(function() {
    var t = $(".dropdown-background");
    $(this).children(".dropdown-menu").stop(!1, !0).fadeIn(300), $(this).hasClass("nav-menu-item") && $(t).stop(!1, !0).fadeIn(300)
  }, function() {
    var t = $(".dropdown-background");
    $(this).children(".dropdown-menu").stop(!1, !0).fadeOut(300), $(this).hasClass("nav-menu-item") && $(t).stop(!1, !0).fadeOut(300)
  }), $(".main-header .main-menu .navbar-nav > li > .dropdown-menu, .main-header .upper-menu .navbar-nav > li > .dropdown-menu").parent().hover(function() {
    var t = $(".main-content").width(),
        e = $(".main-content").offset(),
        n = e.left + t,
        i = $(this).children(".dropdown-menu");
    i.css({
      left: "",
      right: ""
    }), $(i).offset().left + i.width() > n && i.css({
      left: "auto",
      right: "0"
    })
  }, function() {}), $(".main-header .main-menu .navbar-nav > li > .dropdown-menu > li > .dropdown-menu, .main-header .upper-menu .navbar-nav > li > .dropdown-menu > li > .dropdown-menu").parent().hover(function() {
    var t = $(".main-content").width(),
        e = $(".main-content").offset(),
        n = e.left + t,
        i = $(this).find(".dropdown-menu"),
        r = i.width();
    if (i.css({
      left: ""
    }), $(this).find(".dropdown-menu .dropdown-menu .dropdown-menu").length) var s = 3 * r;
    else if ($(this).find(".dropdown-menu .dropdown-menu").length) var s = 2 * r;
    else var s = r;
    $(i).offset().left + s > n && i.css({
      left: -r
    })
  }, function() {}), $(".main-header .main-menu .navbar-nav > .has-mega-menu").hover(function() {
    var t = $(this),
        e = $(".main-header > .primary-navigation > .fullwidth-container > .row").offset(),
        n = $(".main-menu-content").offset(),
        i = n.left - e.left,
        r = $(".dropdown-background");
    $(t).children(".mega-menu-container").css({
      marginLeft: -(i + 30),
      marginRight: -(i + 30)
    }), $(t).children(".mega-menu-container").stop(!1, !0).fadeIn(300), $(r).stop(!1, !0).fadeIn(300)
  }, function() {
    var t = $(this),
        e = $(".dropdown-background");
    $(t).children(".mega-menu-container").stop(!1, !0).fadeOut(300), $(e).stop(!1, !0).fadeOut(300)
  }), $(".main-header .upper-menu .navbar-nav > .has-mega-menu").hover(function() {
    var t = $(this),
        e = $(".main-header > .primary-navigation > .fullwidth-container > .row").offset(),
        n = $(".upper-menu.upper-menu-right").offset(),
        i = n.left - e.left,
        r = $(".dropdown-background");
    $(t).children(".mega-menu-container").css({
      left: -(i + 30),
      marginRight: -30
    }), $(t).children(".mega-menu-container").stop(!1, !0).fadeIn(300), $(r).stop(!1, !0).fadeIn(300)
  }, function() {
    var t = $(this),
        e = $(".dropdown-background");
    $(t).children(".mega-menu-container").stop(!1, !0).fadeOut(300), $(e).stop(!1, !0).fadeOut(300)
  }), $(".main-header .nav-item-search .nav-link:not(.main-header.sticky-header .nav-item-search .nav-link)").click(function(t) {
    t.preventDefault();
    $(".main-header .nav-item-search .nav-link").parent().hasClass("active") ? $(document).trigger("selectlayers.fadeSearchOut", []) : ($(document).trigger("selectlayers.fadeSearchResponsive", []), $(document).trigger("selectlayers.fadeSearchIn", [0]))
  }), $(".search-background").click(function() {
    $(document).trigger("selectlayers.fadeSearchOut", [])
  }), $(document).on("selectlayers.fadeSearchIn", function(t, e) {
    var n = $(document).find(".main-header .desktop-search"),
        i = $(document).find(".search-background");
    $(".main-header .nav-item-search .nav-link:not(.main-header.sticky-header .nav-item-search .nav-link)").parent().addClass("active"), $(".main-header .nav-item-search .nav-link:not(.main-header.sticky-header .nav-item-search .nav-link)").parent().removeClass("out"), $(".main-header .nav-item-search .nav-link:not(.main-header.sticky-header .nav-item-search .nav-link)").parent().addClass("in"), $("body").addClass("animate-menu-links-out"), $(i).stop(!1, !0).fadeIn(300), setTimeout(function() {
      $("body").addClass("animate-menu-links-active"), $("body").removeClass("animate-menu-links-out"), $("body").addClass("animate-search-in"), $("body").removeClass("animate-search-out"), $(n).stop(!1, !0).fadeIn(300)
    }, 700)
  }), $(document).on("selectlayers.fadeSearchOut", function(t) {
    var e = $(document).find(".main-header .desktop-search"),
        n = $(document).find(".search-background");
    $(".main-header .nav-item-search .nav-link:not(.main-header.sticky-header .nav-item-search .nav-link)").parent().removeClass("active"), $(".main-header .nav-item-search .nav-link:not(.main-header.sticky-header .nav-item-search .nav-link)").parent().removeClass("in"), $(".main-header .nav-item-search .nav-link:not(.main-header.sticky-header .nav-item-search .nav-link)").parent().addClass("out"), $("body").removeClass("animate-search-in"), $("body").addClass("animate-search-out"), $(e).stop(!1, !0).fadeOut(300), setTimeout(function() {
      $("body").addClass("animate-menu-links-in")
    }, 300), setTimeout(function() {
      $("body").removeClass("animate-menu-links-active"), $("body").removeClass("animate-menu-links-in"), $(n).stop(!1, !0).fadeOut(300)
    }, 1e3)
  }), $(document).on("selectlayers.fadeSearchResponsive", function(t) {
    var e = $(document).find(".main-header .desktop-search .quickSearchResults .search-results-container"),
        n = $(".main-header > .primary-navigation > .fullwidth-container > .row").offset(),
        i = $(".main-menu-content").offset(),
        r = i.left - n.left;
    $(e).css({
      marginLeft: -r,
      marginRight: -r
    })
  }), $(".main-header.sticky-header .nav-item-search .nav-link").click(function(t) {
    t.preventDefault();
    $(".main-header .nav-item-search .nav-link").parent().hasClass("active") ? $("html, body").animate({
      scrollTop: "0px"
    }, 300) : ($("html, body").animate({
      scrollTop: "0px"
    }, 300), setTimeout(function() {
      $(document).trigger("selectlayers.fadeSearchResponsive", []), $(document).trigger("selectlayers.fadeSearchIn", [0])
    }, 300))
  }), $(".main-header .nav-item-mobile-menu .nav-link:not(.main-header.sticky-header .nav-item-mobile-menu .nav-link)").click(function() {
    var t = $(this),
        e = $("body"),
        n = $(".main-header .mobile-menu"),
        i = $(document).find(".main-header .mobile-menu .navbar-search:not(.main-header.sticky-header .mobile-menu .navbar-search)"),
        r = $(document).find(".main-header .mobile-menu .navbar-nav:not(.main-header.sticky-header .mobile-menu .navbar-nav)");
    $(t).parent().hasClass("active") ? (e.removeClass("menu-open"), n.removeClass("mobile-menu--open"), $(t).parent().removeClass("active"), $(t).parent().removeClass("in"), $(t).parent().addClass("out"), $(i).stop(!1, !0).slideUp(300, function() {
      $(i).css("overflow", "")
    }), $(r).stop(!1, !0).slideUp(300, function() {
      $(r).css("overflow", "")
    })) : (e.addClass("menu-open"), n.addClass("mobile-menu--open"), $(t).parent().addClass("active"), $(t).parent().removeClass("out"), $(t).parent().addClass("in"), $(i).stop(!1, !0).slideDown(300, function() {
      $(i).css("overflow", "")
    }), $(r).stop(!1, !0).slideDown(300, function() {
      $(r).css("overflow", "")
    }))
  }), $(".main-header.sticky-header .nav-item-mobile-menu .nav-link").click(function() {
    var t = $(this),
        e = $(document).find(".main-header.sticky-header .mobile-menu .navbar-nav");
    $(t).parent().hasClass("active") ? ($(t).parent().removeClass("active"), $(t).parent().removeClass("in"), $(t).parent().addClass("out"), $(e).stop(!1, !0).slideUp(300, function() {
      $(e).css("overflow", "")
    })) : ($(t).parent().addClass("active"), $(t).parent().removeClass("out"), $(t).parent().addClass("in"), $(e).stop(!1, !0).slideDown(300, function() {
      $(e).css("overflow", "")
    }))
  }), $(".main-header .mobile-menu .navbar-nav .nav-item .dropdown-toggle-button").click(function() {
    var t = $(this),
        e = $(this).parent(),
        n = $(e).children(".dropdown-menu");
    $(t).hasClass("active") ? ($(t).removeClass("active"), $(n).stop(!1, !0).slideUp(300)) : ($(t).addClass("active"), $(n).stop(!1, !0).slideDown(300))
  });
  var h = $(document).find(".main-header:not(.main-header.sticky-header)"),
      m = $(document).find(".main-header.sticky-header");
  if ($(m).length) {
    $(m).data("sticky-header-active", "false");
    var g = (parseInt($(m).attr("data-sticky-header-height")) || 0) + 10;
    $(window).scroll(function() {
      var t = $(window).scrollTop(),
          e = 0,
          n = 0;
      if ($(h).length) var e = $(h).offset().top + $(h).height();
      var i = $(".main-header .main-menu-logo"),
          r = $(".main-header .main-menu.mobile-menu-icon-wrapper .navbar-nav");
      if ($(i).length && $(r).length && $(h).width() < $(i).width() + $(r).width()) var n = g;
      t > e ? "false" == $(m).data("sticky-header-active") && ($(m).data("sticky-header-active", "true"), $(m).css({
        top: -(g + n)
      }), $(m).addClass("sticky-header-active"), $(m).stop(!0, !1).animate({
        top: "0px"
      }, 500)) : "true" == $(m).data("sticky-header-active") && ($(m).data("sticky-header-active", "false"), $(m).removeClass("sticky-header-active"))
    })
  }
  /*---------------- HEADER END ------------------*/
   });